

export abstract class GQLQueryProvider {
    abstract save(obj: any): Promise<any>;
}
